import btnStyle from '@/components/Shares/Button.module.css';
import inputStyle from '@/components/Shares/Input.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Button, Card, Input, Stack, Text, rem } from '@mantine/core';
export const SecurityPasswordCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="var(--bg-400)">
      <Text fz={{
      base: rem(14),
      sm: rem(18)
    }} mt={{
      base: 10,
      sm: 12
    }} className={gunterzBold.className}>
        {i18n._('Password')}
      </Text>

      <form>
        <Stack gap={10} mt={24}>
          <Input placeholder={i18n._('Old password')} classNames={{
          input: inputStyle.input_style_2
        }} />
          <Input placeholder={i18n._('New password')} classNames={{
          input: inputStyle.input_style_2
        }} />
          <Input placeholder={i18n._('Confirm password')} classNames={{
          input: inputStyle.input_style_2
        }} />
          <Button w={96} mt={14} type="submit" classNames={{
          root: btnStyle.button_style_2
        }}>
            {i18n._('Save')}
          </Button>
        </Stack>
      </form>
    </Card>;
};